import styled from 'styled-components';

export const Title = styled.h3 `
    font-size: 3em;
    text-transform: uppercase;
    font-family: 'zx_spectrum7_boldregular', sans;
`;
